export const enum HeaderSavedPropertiesCssSelectorEnum {
  element = '[data-qs=header-saved-properties]',
  button = '[data-qs=header-saved-properties-button]',
  counter = '[data-qs=header-saved-properties-counter]',
  notification = '[data-qs=header-saved-properties-notification]',
  label = '[data-qs=header-saved-properties-label]',
}
